module.exports = __webpack_public_path__ + "img/p45.46471e46.svg";